import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, Mic, Sparkles, Radio, Repeat } from 'lucide-react';

const audiences = [
  { icon: ShoppingBag, label: 'DTC & ecommerce brands', sub: 'Convert net-new buyers, not impressions.' },
  { icon: Mic, label: 'Podcast networks & shows', sub: 'Grow listenership beyond the host-read.' },
  { icon: Sparkles, label: 'Creators & influencers', sub: 'Audience-building that compounds.' },
  { icon: Radio, label: 'Social sellers & live-commerce', sub: 'Demand at the moment of intent.' },
  { icon: Repeat, label: 'Subscription & memberships', sub: 'Lower CAC. Better LTV. Real retention.' },
];

export default function WhoWeWorkWith({ id = 'who-we-work-with', titleCase = false }) {
  return (
    <section id={id} className="relative py-24 md:py-32 bg-[#0B0F2A] text-white">
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-4xl">
          <p className="text-sm sm:text-base font-semibold uppercase tracking-[0.22em] text-[#FF5081]">Who we work with</p>
          <h2 className={`mt-5 font-display text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-[-0.025em] leading-[1.02] ${titleCase ? 'capitalize' : ''}`}>
            We run media for businesses.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {audiences.map((a, i) => (
            <motion.div
              key={a.label}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="group rounded-2xl p-7 bg-white/[0.03] border border-white/10 hover:border-white/25 hover:bg-white/[0.05] transition-all"
            >
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[#FF5081]/10 text-[#FF5081] border border-[#FF5081]/20">
                <a.icon className="w-[18px] h-[18px]" strokeWidth={1.75} />
              </span>
              <h3 className="mt-5 font-display text-xl font-semibold tracking-tight leading-snug">{a.label}</h3>
              <p className="mt-2 text-white/55 text-[15px] leading-relaxed">{a.sub}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 max-w-3xl">
          <p className="text-lg lg:text-xl leading-relaxed text-white/65">
            Buyers and audiences — not just impressions. If your growth depends on reaching the right people
            efficiently, building revenue, and creating a sustainable customer base, Sellrly is built for you.
          </p>
        </div>
      </div>
    </section>
  );
}
